<mat-card class="summary-card">
  <mat-card-header>
    <mat-card-title>Total Owed to All Charities</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="total-owed">
      <span class="total-owed-amount">{{ totalOwed | formatCurrency }}</span>
    </div>
  </mat-card-content>
</mat-card>

<app-table-export-buttons
  testIdPrefix="balances"
  [disabled]="uiState === UIStateEnum.ShowLoading"
  (exportCsv)="onExportCsv()"
  (exportPdf)="onExportPdf()">
</app-table-export-buttons>

<!-- 140 charities on the biggest game, and the row you want is usually near the top once sorted by owed. -->
<ag-grid-angular
  class="ag-theme-quartz"
  rowClass="balance-row"
  [tooltipShowDelay]=0
  domLayout='autoHeight'
  [pagination]="true"
  [paginationPageSize]="50"
  [paginationPageSizeSelector]="[25, 50, 100, 250]"
  data-testid="balances-table"
  [loading]="uiState == UIStateEnum.ShowLoading"
  overlayNoRowsTemplate="<span>No charity balances found for this game</span>"
  (gridReady)="onBalancesGridReady($event)"
  [rowData]="charityBalances"
  [columnDefs]="balanceColDefs">
</ag-grid-angular>

@if (uiState === UIStateEnum.ShowLoading) {
  <app-loading-card-content></app-loading-card-content>
}
